import { css } from '@emotion/core'
import { spacing, colors, font } from 'styles/variables'

export const logo = css`
  width: ${spacing(4.5)};
  margin-right: ${spacing(1)};
`

export const container = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
export const teamItem = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const winnerLabel = css`
  color: ${colors.greens.green6};
  margin-right: ${spacing(2.5)};
  font-weight: ${font.weight.medium};
`
export const looserLabel = css`
  color: ${colors.errors.error3};
  margin-right: ${spacing(2.5)};
  font-weight: ${font.weight.medium};
`

export const customEventName = css`
  font-weight: ${font.weight.medium};
  color: ${colors.greens.green6};
`

export const customEventDesc = css`
  color: ${colors.white100};
  margin-left: ${spacing(1)};
`
